// 261015 P4c-2c-1 (D9) — nhãn "kịch bản này viết với bản tổng quan nào" ở đầu khung tập ⑤ (cạnh dòng `qualityReviewLine`). THUẦN (jest). KHÔNG import antd / react.
// Đây là THÔNG BÁO nhẹ (không lỗi, không chip đỏ, không chặn): người biết tập nào đã hưởng tổng quan hiện tại, tập nào nên viết lại.
// Nguồn: BE GET scripts → `overviewReceipt` mỗi dòng. Chỉ hiện khi truyện CÓ tổng quan (`outline.overview`) và tập ĐÃ có kịch bản.
import type { EpisodeScriptRecord, FilmOutline, OverviewReceiptState } from '../../../types/adaptation';

/** Chữ nhãn theo trạng thái biên lai. Đổi chữ ở đây thì đổi cả test. */
export const OVERVIEW_RECEIPT_TEXT: Record<OverviewReceiptState, string> = {
  MATCH: 'Viết theo tổng quan hiện tại',
  DIFFERENT: 'Viết với tổng quan cũ — Viết lại tập để dùng bản mới',
  NONE: 'Viết khi chưa dùng tổng quan',
};

export interface OverviewReceiptLabel {
  state: OverviewReceiptState;
  text: string;
  /** `ok` = khớp bản hiện tại · `info` = không khớp / chưa dùng (vẫn là thông báo trung tính, KHÔNG đỏ). */
  tone: 'ok' | 'info';
}

/** Truyện có tổng quan ⇔ khung xương có `overview` (truyện cũ / chưa tạo: vắng ⇒ không nhãn). */
export const outlineHasOverview = (outline: Pick<FilmOutline, 'overview'> | null | undefined): boolean => !!outline?.overview;

const isState = (v: unknown): v is OverviewReceiptState => v === 'MATCH' || v === 'DIFFERENT' || v === 'NONE';

/**
 * Nhãn biên lai của MỘT tập. `null` khi: truyện không có tổng quan · tập chưa có kịch bản (dòng FAILED / chưa viết) · BE cũ không trả `overviewReceipt` / giá trị lạ.
 * (Fail-closed về phía im lặng: không bịa nhãn khi không biết.)
 */
export const overviewReceiptLabel = (
  rec: Pick<EpisodeScriptRecord, 'script' | 'overviewReceipt'> | null | undefined,
  hasOverview: boolean,
): OverviewReceiptLabel | null => {
  if (!hasOverview || !rec?.script) return null;
  const state = rec.overviewReceipt;
  if (!isState(state)) return null;
  return { state, text: OVERVIEW_RECEIPT_TEXT[state], tone: state === 'MATCH' ? 'ok' : 'info' };
};
